import { Item, Image, Button, lucideIcons } from '@round/creatorbase-ui';

import { ProjectCampaignOption } from '../useProjectCampaignGroups';

import styles from './CampaignItem.module.css';
import cn from 'classnames';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import capitalize from 'lodash/capitalize';

const { XIcon } = lucideIcons;

type Props = {
    campaign: ProjectCampaignOption;
    image?: string | null;
    isClearable?: boolean;
    onClear?: () => void;
    isSelected?: boolean;
    onSelect?: () => void;
    className?: string;
};

const CampaignItem = ({ campaign, image, isSelected, isClearable, onClear, onSelect, className }: Props) => {
    const { getCurrencyById } = useCurrencies();
    const currency = getCurrencyById(campaign.currency_id);
    const subtitle = `${capitalize(campaign.platform)}${currency?.name ? ` · ${currency.name}` : ''}`;

    return (
        <Item
            variant={isSelected ? 'muted' : 'default'}
            size="sm"
            className={cn(styles.item, className)}
            onClick={onSelect}
        >
            {image && (
                <Item.Media variant="default" className={styles.media}>
                    <Image src={image ?? ''} alt={campaign.label} className={styles.campaignImage} />
                </Item.Media>
            )}

            <Item.Content>
                <Item.Title className={styles.title}>{campaign.label}</Item.Title>
                <Item.Description>{subtitle}</Item.Description>
            </Item.Content>

            {isClearable && (
                <Item.Actions>
                    <Button variant="ghost" size="icon-sm" onClick={onClear}>
                        <XIcon />
                    </Button>
                </Item.Actions>
            )}
        </Item>
    );
};

export default CampaignItem;
